import BaseUpdateRequest from '@/models/Shared/BaseUpdateRequest';
import ConversationTopicType from '@/models/ConversationTopics/ConversationTopicType';


export default class UpdateConversationTopicRequest extends BaseUpdateRequest {
	name = '';  
    isPublic = false;
	isEnabled = true;
	avatar = '';
	businessHoursId = '';
	isBusinessHoursNotificationEnabled = false;
	businessHoursGroupId = '';
	isOutOfHoursNotificationEnabled = false;
	outOfHoursGroupId = '';
	offlineMessage = '';
}